import styled from 'styled-components'
import { PageWrapper } from '../styles'

export const Wrapper = styled(PageWrapper)`
  /* Common spacing between each page section */
  > *:last-child {
    margin-bottom: 0;
  }
`
